module.exports = __webpack_public_path__ + "img/3-2.fc4e7e30.svg";